import { useLayoutEffect, useState, useEffect } from 'react';
import { Button, Image } from 'semantic-ui-react'

import prepareStyles from '../styles/renderer'

import styles from '../../styles/Controls.module.css'
import Controls from '../helper/controls'

export default function CustomComponent(props) {
    const [hover, setHover] = useState()
    const [style, setStyle] = useState()

    useEffect(() => {
        function updateStyles() {
            let newStyles = prepareStyles(props.style)
            setStyle(newStyles);
        }
        window.addEventListener('resize', updateStyles);
        updateStyles();
        return () => window.removeEventListener('resize', updateStyles);
    }, [ props.style ]);

    useEffect(() => {
        setStyle(prepareStyles(props.style))
    }, []);

    return <a href="#" data-controls style={ style } className={[ hover && !props.hideControls ? styles.highlight : `` ]} onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} onClick={(ev) => { props.handleClick(ev, props.attributes.destination_type, props.attributes.destination) }}>
        <a title="Facebook Sign-In" onPress={() => console.log('Signed in with Facebook!') } style={ style }>
            <Image src={ `/assets/login/facebook-login.svg` } objectFit={`contain`} layout={`intrinsic`} width={ 240 } height={ 45 } />
        </a>
    </a>
}